<template>
  <section class="mainSection">
    <div class="frame">
      <steps :steps="steps"/>
      <form v-if="matricula && active && ready" @change="handleFormChange" @input="handleFormChange" ref="matForm">
        <alunos :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'aluno'" />
        <matricula :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'matricula'"/>
        <planos-pagamento :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'planos-pagamento'"/>
        <filiacao :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'filiacao'"/>
        <responsavel :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'responsaveis'"/>
        <documento :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'documentos'"/>
        <contrato :steps="steps" onChange="" :current="active" :auto="auto" v-if="active.slug == 'contrato'"/>
      </form>
    </div>
    <prev-next @next="toggleNav('next')" @prev="toggleNav('prev')" :prev="prev" :next="next" :auto="auto" />
    <modal ref="modal">
      <div class="wait">
        <input-spinner></input-spinner>
        <h3>Aguarde. Estamos processando sua matrícula</h3>
        <p>Isto pode demorar um pouco. Não feche esta janela até que o processo seja concluído</p>
      </div>
    </modal>
    <confirm ref="confirm"></confirm>
  </section>
</template>

<script>
import matriculaService from '@/services/matricula.service'
import MatriculaTrackingService from '@/services/matricula-tracking.service.js'
import Steps from '@/components/matriculas/4/navigation/Steps.vue'
import PrevNext from '@/components/matriculas/4/navigation/PrevNext.vue'
import Matricula from '@/views/matriculas/4/etapas/Matricula.vue'
import Alunos from '@/views/matriculas/4/etapas/Aluno.vue'
import PlanosPagamento from '@/views/matriculas/4/etapas/PlanosPagamento.vue'
import Filiacao from '@/views/matriculas/4/etapas/Filiacao.vue'
import Contrato from '@/views/matriculas/4/etapas/Contrato.vue'
import Documento from '@/views/matriculas/4/etapas/Documento.vue'
import Responsavel from '@/views/matriculas/4/etapas/Responsavel.vue'
import Modal from '@/components/utilities/Modal.vue'
import Confirm from '@/components/utilities/Confirm.vue'
import InputSpinner from '@/components/utilities/InputSpinner.vue'
import { unformatDate } from '@/services/utils.service.js'
// import FormService from '@/services/form.service.js'

export default {
  components: {
    Steps, Matricula, PrevNext, Alunos, PlanosPagamento, Filiacao, Contrato, Responsavel, Documento, Modal, Confirm, InputSpinner
  },
  props: {
    action: String,
    step: String,
    idMatricula: [String, Number],
    auto: Boolean
  },
  data () {
    return {
      currentRoute: null,
      matricula: null,
      wait: false,
      steps: [
        {
          title: 'Aluno',
          slug: 'aluno',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: false,
          exec: 0
        },
        {
          title: 'Matrícula',
          slug: 'matricula',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: true,
          exec: 0,
        },
        {
          title: 'Filiação',
          slug: 'filiacao',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: false,
          exec: 0
        },
        {
          title: 'Responsáveis',
          slug: 'responsaveis',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: false,
          exec: 0
        },
        {
          title: 'Documentos',
          slug: 'documentos',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: false,
          exec: 0
        },
        {
          title: 'Pagamento',
          slug: 'planos-pagamento',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: true,
          exec: 0
        },
        {
          title: 'Contrato',
          slug: 'contrato',
          status: 'idle', //idle, active, error, done
          mat: true,
          rema: true,
          exec: 0
        }
      ],
      active: null,
      prev: false,
      next: true,
      ready: false,
      type: null,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      trackingSessionId: MatriculaTrackingService.getSessionId(),
      trackingStarted: false,
      lastTrackedStep: null
    }
  },
  watch: {
    step ( value ) {
      console.log("step changed after routing...", value)
      if ( value ) {
        this.setup()
      }
    },
    idMatricula ( value, oldValue ) {
      if ( value != oldValue ) {
        this.setup()
      }
    }
  },
  mounted () {
    this.currentRoute = this.currentRouter()

    if ( this.idMatricula ) {
      if ( !this.step ) {
        const newParams = {
          ...this.currentRoute.params,
          step: 'matricula'
        }
        this.$router.push({name: this.currentRoute.name, params: newParams })
      }
    } else {
      if ( !this.step || this.step != 'aluno' ) {
        // const newParams = this.currentRoute.params
        //       newParams.step = 'aluno'
        const newParams = {
            ...this.currentRoute.params,
            step: 'aluno'
          }
        console.log("currentRoute:", this.currentRoute.name)
        console.log("newParams:", newParams)

        this.$router.push({name: this.currentRoute.name, params: newParams })
        
      }
      console.log("step on load:", this.step)
    }

    this.setup()
  },
  methods: {
    currentRouter () {
      return this.$route || this.$router.currentRoute?._value || this.currentRoute?._value || this.currentRoute || {}
    },
    idMatriculaTracking () {
      return this.matricula?.matricula?.idMatricula || this.idMatricula || null
    },
    fluxoMatricula () {
      const route = this.currentRouter()
      const routeName = route.name || this.type || null
      const primeiraMatricula = this.matricula?.matricula?.primeiraMatricula

      if ( routeName === 'rematricula' || this.action === 'rematricula' || primeiraMatricula === 0 || primeiraMatricula === '0' ) {
        return 'rematricula'
      }

      return 'matricula'
    },
    progressoEtapa ( step ) {
      if ( !step || !this.steps.length ) return 0
      if ( step.exec ) return step.exec

      const index = this.steps.findIndex(item => item.slug === step.slug)
      if ( index < 0 ) return 0

      return Math.round(((index + 1) / this.steps.length) * 100)
    },
    mensagemErroTracking ( error ) {
      if ( !error?.response?.data ) return error?.message || 'Erro desconhecido'

      const data = error.response.data

      if ( data.error ) return data.error
      if ( data.message ) return data.message

      return Object.values(data).join(', ') || 'Erro desconhecido'
    },
    trackMatricula ( acao, status = 'em_andamento', options = {} ) {
      const route = this.currentRouter()
      const step = options.step || this.active

      return MatriculaTrackingService.track({
        idMatricula: options.idMatricula || this.idMatriculaTracking(),
        idPessoaResponsavel: this.currentUser?.idPessoa || null,
        fluxo: this.fluxoMatricula(),
        etapa: options.etapa || step?.slug || null,
        acao,
        status,
        progresso: options.progresso ?? this.progressoEtapa(step),
        sessionId: this.trackingSessionId,
        origem: 'apollo',
        rota: window.location.pathname,
        envelopeId: options.envelopeId || null,
        outboxUuid: options.outboxUuid || null,
        erro: options.erro || null,
        metadata: {
          action: this.action,
          routeName: route.name || this.type || null,
          canal: this.auto ? 'automatricula' : 'apollo',
          ...(options.metadata || {})
        }
      })
    },
    trackFluxoIniciado () {
      if ( this.trackingStarted || !this.active ) return

      this.trackingStarted = true
      this.trackMatricula('fluxo_iniciado', 'em_andamento', {
        step: this.active
      })
    },
    trackEtapaVisualizada ( step = this.active, metadata = {} ) {
      if ( !step ) return

      const key = `${step.slug}:${this.idMatriculaTracking() || ''}`
      if ( this.lastTrackedStep === key ) return

      this.lastTrackedStep = key
      this.trackMatricula('etapa_visualizada', 'em_andamento', {
        step,
        metadata
      })
    },
    trackEtapaSalva ( step, params ) {
      this.trackMatricula('etapa_salva', 'concluido', {
        step,
        metadata: {
          proximaEtapa: params?.step || null
        }
      })
    },
    trackEtapaErro ( error, status = 'erro' ) {
      this.trackMatricula('etapa_salvar_erro', status, {
        step: this.active,
        erro: this.mensagemErroTracking(error)
      })
    },
    cloneData ( data ) {
      return JSON.parse(JSON.stringify(data || {}))
    },
    async setup () {
      this.currentRoute = this.currentRouter()
      this.type = this.currentRoute.name
      this.ready = false

      const currentStore = await this.$store.dispatch('matricula/get')
      const currentIdMatricula = currentStore?.matricula?.idMatricula
      const routeIdMatricula = this.idMatricula || null
      const shouldClearStore = !!(
        ( routeIdMatricula && currentIdMatricula && String(currentIdMatricula) != String(routeIdMatricula) ) ||
        ( !routeIdMatricula && currentIdMatricula )
      )

      if ( shouldClearStore ) {
        await this.$store.dispatch('matricula/clear')
        this.matricula = null
      }

      this.rewriteSteps()
      this.setActive()
      this.trackFluxoIniciado()
      this.trackEtapaVisualizada()
    
      if ( this.idMatricula ) {
        this.getMatricula()
        this.setupNav()
      } else {
        this.$store.dispatch('matricula/get').then(response => {
          console.log("get matriculas on load new...", response)
          this.matricula = response

          if ( !this.matricula.matricula.primeiraMatricula ) this.matricula.matricula.primeiraMatricula = 1
          this.validateParams()
          this.setupNav()

          this.$store.dispatch('matricula/save', this.steps).then(() => {
            this.ready = true

            setTimeout(() => {
              this.calculateProgress()
            },1000)
          })
        })
      }
    },
    rewriteSteps () {
      if ( this.type == 'matricula' ) {
        this.steps = this.steps.filter( a => a.mat )
      }
      if ( this.type == 'rematricula' || this.type == 'automatricula' ) {
        this.steps = this.steps.filter( a => a.rema )
      }
    },
    validateParams () {
      if ( this.idMatricula ) {
        if ( this.primeiraMatricula && this.type == 'rematricula' ) {
          const params = {
            ...this.currentRoute.params
          }
          this.$router.push({name: 'matricula',  params: params  })
          this.rewriteSteps ()
        }

        if ( ( this.primeiraMatricula == 0 ) && this.type == 'matricula' ) {
          const params = {
            ...this.currentRoute.params
          }
          this.$router.push({name: 'rematricula',  params: params  })
          this.rewriteSteps ()
        }

        if ( this.action == 'nova' && this.matricula.matricula.idSituacao == 1 ) {
          const params = {
            ...this.currentRoute.params,
            action: 'editar'
          }
          this.$router.push({name: this.currentRoute.name,  params: params  })
          this.rewriteSteps ()
        }
      } else {
        if ( !this.step ) {
          const params = {
            ...this.currentRoute.params,
            step: 'aluno'
          }

          this.$router.push({name: this.currentRoute.name,  params: params  })
          this.rewriteSteps ()
        } else {
          const params = {
            ...this.currentRoute.params,
            action: 'nova'
          }
          this.$router.push({name: this.currentRoute.name,  params: params  })
          this.rewriteSteps ()
        }
      }
      
      // this.setActive()
    },
    getMatricula () {
      this.$store.dispatch('matricula/get').then(storeResponse => {
        this.matricula = storeResponse

        // console.log('idMatricula:', this.idMatricula)
        matriculaService.getAlunoByIdMatricula(this.idMatricula)
        .then( response => {
          console.log('getMatricula --------:', response.data)
          this.matricula.matricula = response.data.matricula
          if ( response.data.aluno ) {
            this.populateAluno(response.data.aluno)
          }

          // this.matricula.aluno.Basicos.nome = response.data.aluno.Basicos.nome
          // this.matricula.aluno.Basicos.idPessoa = response.data.aluno.Basicos.idPessoa

          this.$store.dispatch('matricula/save', this.steps).then(() => {
            this.ready = true

            setTimeout(() => {
              this.calculateProgress()
            },1000)
          })
        })
        .catch ( error => {
          console.error(error)
        })
        .finally(() => {
          this.validateParams()
        })
      })
      
    },
    populateAluno ( aluno ) {
      console.log("populateAluno:", aluno)
      if ( aluno.Basicos ) {
        this.matricula.aluno.Basicos = aluno.Basicos
        this.matricula.aluno.Basicos.dataNascimento = this.matricula.aluno.Basicos.dataNascimento
          ? unformatDate(this.matricula.aluno.Basicos.dataNascimento)
          : this.matricula.aluno.Basicos.dataNascimento
      }

      if ( aluno.Endereco ) {
        this.matricula.aluno.endereco = aluno.Endereco
      }

      if ( aluno.Aluno ) {
        this.matricula.aluno.aluno = {
          idUnidade: aluno.Aluno.idUnidade,
          idAluno: aluno.Aluno.idAluno,
          escolaAnterior: aluno.Aluno.escolaAnterior,
          idPessoa: aluno.Aluno.idPessoa
        }
      }

      if ( aluno.Documento ) {
        this.matricula.aluno.documento = {
          idDocumento: aluno.Documento.idDocumento,
          cpf: aluno.Documento.cpf,
          idPessoa: aluno.Documento.idPessoa,
          nomeOrgaoEmissor: aluno.Documento.nomeOrgaoEmissor,
          rg: aluno.Documento.rg,
          rgEmissor: aluno.Documento.rgEmissor
        }
      }
    },
    setFiliacaoToResp ( target ) {
      console.log("setFiliacaoToResp:", target)
      // console.log("data:", data)
      const obj = Object.assign({}, this.matricula[target])
      delete obj.filiacao

      console.log('setFiliacaoToResp - obj:', obj)
      if ( this.matricula[target].responsavel.financeiro ) {
        this.matricula.responsavelFinanceiro = obj
      }
      if ( this.matricula[target].responsavel.pedagogico ) {
        this.matricula.responsavelPedagogico = obj
      }
    },
    hasResponsavelNaFiliacao ( type ) {
      return this.matricula.filiacao1.responsavel?.[type] == 1 ||
        this.matricula.filiacao2.responsavel?.[type] == 1
    },
    hasTodosResponsaveisNaFiliacao () {
      return this.hasResponsavelNaFiliacao('financeiro') &&
        this.hasResponsavelNaFiliacao('pedagogico')
    },
    emptyResponsavel ( type ) {
      const responsavel = Object.assign({}, JSON.parse(JSON.stringify(this.matricula.Basic)))

      responsavel.responsavel = {
        idMatricula: this.matricula.matricula.idMatricula,
        financeiro: type == 'financeiro' ? 1 : 0,
        pedagogico: type == 'pedagogico' ? 1 : 0,
        diavencimento: null
      }

      return responsavel
    },
    prepareResponsaveisStep () {
      if ( !this.hasResponsavelNaFiliacao('financeiro') ) {
        this.matricula.responsavelFinanceiro = this.emptyResponsavel('financeiro')
      }

      if ( !this.hasResponsavelNaFiliacao('pedagogico') ) {
        this.matricula.responsavelPedagogico = this.emptyResponsavel('pedagogico')
      }
    },
    applyPessoaSaveResponse ( branch, response ) {
      const data = response?.data?.data || {}
      const target = this.matricula?.[branch]

      if ( !target ) return

      if ( data.pessoa ) {
        target.Basicos = data.pessoa
      } else if ( data.documento?.idPessoa ) {
        target.Basicos.idPessoa = data.documento.idPessoa
      }

      if ( data.endereco ) {
        target.endereco = data.endereco
      }

      if ( data.documento ) {
        target.documento = {
          ...(target.documento || {}),
          ...data.documento
        }
      }

      if ( data.responsavel && target.responsavel ) {
        target.responsavel = data.responsavel
      }

      if ( data.aluno && target.aluno ) {
        target.aluno = {
          ...(target.aluno || {}),
          ...data.aluno
        }
      }
    },
    setActive () {
      // console.log("setActive", this.steps)
      this.steps.map( k => {
        // console.log(`compare ${k.slug} to ${this.step}`)

        if ( k.slug == this.step ) {
          // console.log("compare found:", this.slug)
          k.status = 'active'
          this.active = k
        }
      })
      console.log("ativo:", this.active)
    },
    getActive () {
      const index = this.steps.findIndex(step => step.slug === this.step)
      const item = this.steps.find(step => step.slug === this.step)

      return {index, item: item}
    },
    handleFormChange (e) {
      const el = e.target

      if (!el.matches('input, select, textarea')) return

      this.calculateProgress()
    },
    calculateProgress () {
      const form = this.$refs.matForm
      if (!form) return

      const fields = [...form.querySelectorAll('input, select, textarea')]
        .filter(field => {
          if (!field.required) return false
          if (field.type === 'hidden') return false
          if (field.disabled) return false
          return true
        })

      const groupedFields = []

      fields.forEach(field => {
        if (field.type === 'radio') {
          const alreadyAdded = groupedFields.some(item => {
            return item.type === 'radio' && item.name === field.name
          })

          if (!alreadyAdded) {
            groupedFields.push({
              type: 'radio',
              name: field.name,
              fields: fields.filter(item => {
                return item.type === 'radio' && item.name === field.name
              })
            })
          }

          return
        }

        groupedFields.push(field)
      })

      const filledFields = groupedFields.filter(field => {
        if (field.type === 'radio') {
          return field.fields.some(item => item.checked)
        }

        if (field.type === 'checkbox') {
          return field.checked
        }

        if (field.tagName === 'SELECT') {
          return field.value !== ''
        }

        return String(field.value || '').trim() !== ''
      })

      const progress = groupedFields.length > 0
        ? Math.round((filledFields.length / groupedFields.length) * 100)
        : 0

      const active = this.getActive().index

      this.steps[active].exec = progress

      console.log('Progress:', progress + '%')
    },
    validate () {
      
    },
    setupNav () {
      const active = this.getActive()
      console.log('setupNav:', active)
      if ( active.index > 0 ) {
        this.prev = true
      }
    },
    toggleNav ( dir ) {
      // console.log("active:", this.active)
      // console.log("action:", this.action)
      const current = this.active.slug
      // filter steps based on current action
      const filteredSteps = this.steps.filter(step => {
        if (this.type === 'matricula') {
          return step.mat
        }
        
        if (this.type === 'rematricula' || this.type === 'automatricula' ) {
          return step.rema
        }

        return false
      })

      console.log("filteredSteps", filteredSteps)

      const currentIndex = filteredSteps.findIndex(
        step => step.slug === current
      )

      let nextIndex = currentIndex

      if (dir === 'next' && currentIndex < filteredSteps.length - 1) {
        nextIndex = currentIndex + 1
      }
      if (dir === 'prev' && currentIndex > 0) {
        nextIndex = currentIndex - 1
      }

      console.log("currentIndex", currentIndex)
      console.log("nextIndex", nextIndex)

      const goTo = filteredSteps[nextIndex] || null
      console.log("goTo", goTo)

      const params = {
        ...this.currentRoute.params,
        step: goTo.slug
      }

      if ( dir == 'next' ) {
        this.trackMatricula('etapa_salvar_inicio', 'em_andamento', {
          step: this.active,
          metadata: {
            destino: goTo?.slug || null
          }
        })

        if ( this.matricula.matricula.idSituacao == 1 ) {
          this.goTo(params)
        } else {
          this.save(params)
        }
        
        this.prev = true
      }

      if ( dir == 'prev' ) {
        console.log("prev", currentIndex)
        console.log("prev - params", params)

        this.prev = currentIndex > 0
        this.goTo(params)

        if ( currentIndex == 1 ) this.prev = false
      }
    },
    goTo ( params ) {
      console.log('goTo', params)
      const route = this.currentRouter()
      const routeName = route.name || this.currentRoute.name
      const nextParams = {
        ...route.params,
        ...params
      }

      this.$router.push({name: routeName, params: nextParams }).then(() => {
        this.currentRoute = this.currentRouter()
        this.trackEtapaVisualizada(this.steps.find(step => step.slug === nextParams.step), {
          origem: this.active?.slug || null
        })
      })
    },
    save ( params ) {
      const currentStep = this.active

      if ( this.active.slug != 'contrato' ) {
        window.spinner.emit("open")
      }
      
      if ( this.active.slug == 'aluno' ) {
        console.log('save.aluno', this.matricula)
        if ( !this.matricula.aluno.aluno.idUnidade ) this.matricula.aluno.aluno.idUnidade = this.matricula.matricula.idUnidade
        if ( this.matricula.aluno.Basicos.urlFoto ) delete this.matricula.aluno.Basicos.urlFoto

        matriculaService.savePessoaNew(this.matricula.aluno)
        .then ( response => {
          console.log("saveAluno", response.data)
          this.applyPessoaSaveResponse('aluno', response)
          this.matricula.matricula.idAluno = response.data.data.aluno.idAluno
          // this.matricula.aluno.aluno.rm = response.data.data.aluno.rm
          // this.matricula.aluno.aluno.ra = response.data.data.aluno.ra
          this.matricula.matricula.idSituacao = this.matricula.matricula.idMatricula ? 10 : 12

          window.toaster.emit('open', { style: 'success', message: 'Pessoa salva com sucesso', floater: true })
          this.$store.dispatch('matricula/save', this.steps).then(() => {
            this.ready = true

            setTimeout(() => {
              this.calculateProgress()
            },1000)
          })
          this.trackEtapaSalva(currentStep, params)
          this.goTo(params)
        })
        .catch( error => {
          console.error("Teste: ", error)
          this.trackEtapaErro(error)
          window.toaster.emit('open', { style: 'error', message: error.response.data.error ?? 'Ops! Algo aconteceu. Não foi possível salvar a pessoa ' + error, floater: true })
        })
        .finally (() => {
          window.spinner.emit("close")
        })
      }
 
      if ( this.active.slug == 'matricula' ) {

        matriculaService.saveMatriculaNew(this.matricula.matricula)
        .then( response => {
          window.toaster.emit('open', { style: 'success', message: response.data.message || 'Ops! Algo aconteceu. Não foi possível salvar a matrícula', floater: true })
          this.matricula.matricula = response.data.data

          this.$store.dispatch('matricula/save', this.steps).then(() => {
            if ( this.matricula.matricula.idMatricula ) {
              params.idMatricula = this.matricula.matricula.idMatricula
              // console.log("this.matricula:", this.matricula)
              this.matricula.filiacao1.responsavel['idMatricula'] = this.matricula.matricula.idMatricula
              this.matricula.filiacao2.responsavel['idMatricula'] = this.matricula.matricula.idMatricula
              this.matricula.responsavelFinanceiro.responsavel['idMatricula'] = this.matricula.matricula.idMatricula
              this.matricula.responsavelPedagogico.responsavel['idMatricula'] = this.matricula.matricula.idMatricula
            }

            this.trackEtapaSalva(currentStep, params)
            this.goTo(params)
            this.ready = true
            setTimeout(() => {
              this.calculateProgress()
            },1000)
          })
          
        })
        .catch ( error => {
          console.log('error Melo', error)
          this.trackEtapaErro(error)
          window.toaster.emit('open', { style: 'error', message: error.response.data.error || 'Ops! Algo aconteceu. Não foi possível salvar a matrícula ' + error, floater: true })
        })
        .finally(() => {
          window.spinner.emit("close")
        })
      }

      if ( this.active.slug == 'filiacao' ) {
        // console.log('save.filiacao', this.matricula)
        window.spinner.emit("open")

        const filiacao1 = Object.assign({},JSON.parse(JSON.stringify(this.matricula.filiacao1)))
        const filiacao2 = Object.assign({},JSON.parse(JSON.stringify(this.matricula.filiacao2)))
        
        if ( ( !filiacao1.responsavel?.financeiro || filiacao1.responsavel?.financeiro == 0 ) && ( !filiacao1.responsavel?.pedagogico || filiacao1.responsavel?.pedagogico == 0 ) ) {
          delete filiacao1.responsavel
        } else {
          this.matricula.filiacao1.responsavel.idMatricula = this.matricula.matricula.idMatricula
          filiacao1.responsavel.idMatricula = this.matricula.matricula.idMatricula
        }
        if ( ( !filiacao2.responsavel?.financeiro || filiacao2.responsavel?.financeiro == 0 ) && ( !filiacao2.responsavel?.pedagogico || filiacao2.responsavel?.pedagogico == 0 ) ) {
          delete filiacao2.responsavel
        } else {
          this.matricula.filiacao2.responsavel.idMatricula = this.matricula.matricula.idMatricula
          filiacao2.responsavel.idMatricula = this.matricula.matricula.idMatricula
        }

        if ( !this.matricula.filiacao1?.filiacao.idPessoaAluno ) {
          this.matricula.filiacao1.filiacao.idPessoaAluno = this.matricula.aluno.Basicos.idPessoa
          filiacao1.filiacao.idPessoaAluno = this.matricula.aluno.Basicos.idPessoa
        }
        if ( !this.matricula.filiacao2?.filiacao.idPessoaAluno ) {
          this.matricula.filiacao2.filiacao.idPessoaAluno = this.matricula.aluno.Basicos.idPessoa
          filiacao2.filiacao.idPessoaAluno = this.matricula.aluno.Basicos.idPessoa
        }

        var filiacao1Ready = false
        var filiacao2Ready = false
        var filiacaoGone = false
        this.setFiliacaoToResp('filiacao1')

        matriculaService.savePessoaNew(filiacao1)
        .then( response => {
          
          // const { pessoa, endereco, documento } = response.data.data
          this.applyPessoaSaveResponse('filiacao1', response)
          // this.matricula.filiacao1.Basicos.rescodigo = response.data.data.pessoa.rescodigo
          // this.matricula.filiacao1.endereco = endereco
          // this.matricula.filiacao1.documento = documento

          window.toaster.emit('open', { style: 'success', message: response.data.message || 'Filicação 1 Salva com sucesso!', floater: true })
          this.ready = true

          filiacao1Ready = true
          if ( this.matricula.semFiliacao2 ) filiacao2Ready = true

          if ( filiacao1Ready && filiacao2Ready && !filiacaoGone ) {
            filiacaoGone = true
            if ( this.hasTodosResponsaveisNaFiliacao() ) {
              params.step = 'documentos'
            } else {
              this.prepareResponsaveisStep()
            }

            this.$store.dispatch('matricula/save', this.steps).then(() => {
              this.trackEtapaSalva(currentStep, params)
              this.goTo(params)
            })
          }
        })
        .catch( error => {
          console.error("Error Filiacao 1", error)
          this.trackEtapaErro(error)
          window.toaster.emit('open', { style: 'error', message: error.response.data.error || 'Ops! Algo aconteceu. Não foi possível salvar a matrícula ' + error, floater: true })
        })
        .finally(() => {
          window.spinner.emit("close")
        })

        if ( !this.matricula.semFiliacao2 ) {
          this.setFiliacaoToResp('filiacao2')

          matriculaService.savePessoaNew(filiacao2)
          .then( response => {
            this.applyPessoaSaveResponse('filiacao2', response)
            // this.matricula.filiacao2.Basicos = response.data.data.pessoa
            // this.matricula.filiacao2.endereco = response.data.data.endereco
            // this.matricula.filiacao2.documento = response.data.data.documento
            window.toaster.emit('open', { style: 'success', message: response.data.message || 'Filicação 2 Salva com sucesso!', floater: true })
            this.ready = true
            filiacao2Ready = true

            if ( filiacao1Ready && filiacao2Ready && !filiacaoGone ) {
              filiacaoGone = true

              if ( this.hasTodosResponsaveisNaFiliacao() ) {
                params.step = 'documentos'
              } else {
                this.prepareResponsaveisStep()
              }

              this.$store.dispatch('matricula/save', this.steps).then(() => {
                this.trackEtapaSalva(currentStep, params)
                this.goTo(params)
              })
            }
            // this.goTo(params)
          })
          .catch( error => {
            console.error("Error Filiacao 2", error)
            this.trackEtapaErro(error)
            window.toaster.emit('open', { style: 'error', message: error.response.data.error || 'Ops! Algo aconteceu. Não foi possível salvar a matrícula ' + error, floater: true })
          })
          .finally(() => {
            window.spinner.emit("close")
          })
        }
      } 

      if ( this.active.slug == 'responsaveis' ) {
        // console.log('save.responsaveis', this.matricula)
        if ( this.matricula.responsavelFinanceiro.responsavel?.financeiro == 1 && this.matricula.matricula.idMatricula ) {
          if (this.matricula.responsavelFinanceiroEPedagogico) { 
            this.matricula.responsavelFinanceiro.responsavel.pedagogico = 1
          } else {
            this.matricula.responsavelFinanceiro.responsavel.pedagogico = 0
          }
          // console.log('save.responsaveis.financeiro', this.matricula.responsavelFinanceiro)
          this.matricula.responsavelFinanceiro.responsavel.idMatricula = this.matricula.matricula.idMatricula
          matriculaService.savePessoaNew(this.matricula.responsavelFinanceiro)
          .then( response => {
            console.log('response - save.responsaveis: ',response)
            this.applyPessoaSaveResponse('responsavelFinanceiro', response)
            window.toaster.emit('open', { style: 'success', message: response.data.message || 'Responsável financeiro salvo com sucesso!', floater: true })
            if ( !this.matricula.responsavelPedagogico.documento.cpf || this.matricula.responsavelFinanceiroEPedagogico ) {
              this.$store.dispatch('matricula/save', this.steps).then(() => {
                this.ready = true
                setTimeout(() => {
                  this.calculateProgress()
                },1000)
              })
              this.trackEtapaSalva(currentStep, params)
              this.goTo(params)
            }
          })
          .catch( error => {
            console.error("Error save.responsaveis.financeiro", error)
            this.trackEtapaErro(error)
            window.toaster.emit('open', { style: 'error', message: error.response.data.error || 'Ops! Algo aconteceu. Não foi possível salvar o responsável pedagógico ' + error, floater: true })
          })
          .finally(() => {
            window.spinner.emit("close")
          })
        }
        if ( this.matricula.responsavelPedagogico.responsavel?.pedagogico == 1 && this.matricula.matricula.idMatricula && !this.matricula.responsavelFinanceiroEPedagogico ) {
          console.log('save.responsaveis.pedagogico', this.matricula.responsavelPedagogico)
          this.matricula.responsavelPedagogico.responsavel.idMatricula = this.matricula.matricula.idMatricula
          matriculaService.savePessoaNew(this.matricula.responsavelPedagogico)
          .then( response => {
            console.log('response - save.responsaveis.pedagogico: ',response)
            this.applyPessoaSaveResponse('responsavelPedagogico', response)
            window.toaster.emit('open', { style: 'success', message: response.data.message || 'Responsável pedagógico salvo com sucesso!', floater: true })
            this.$store.dispatch('matricula/save', this.steps).then(() => {
              this.ready = true
              setTimeout(() => {
                this.calculateProgress()
              },1000)
            })
            this.trackEtapaSalva(currentStep, params)
            this.goTo(params)
          })
          .catch( error => {
            console.error("Error save.responsaveis.pedagogico", error)
            this.trackEtapaErro(error)
            window.toaster.emit('open', { style: 'error', message: error.response.data.error || 'Ops! Algo aconteceu. Não foi possível salvar o responsável pedagógico ' + error, floater: true })
          })
          .finally(() => {
            window.spinner.emit("close")
          })
        }
      }

      if ( this.active.slug == 'documentos' ) {
        console.log('save.documentos', this.matricula)
        this.trackEtapaSalva(currentStep, params)
        this.goTo(params)
      }

      if ( this.active.slug == 'planos-pagamento' ) {

        const idMatricula = this.idMatricula
        const planoPagamento = this.matricula.planoPagamento?.codigo

        // console.log("idMatricula:", idMatricula)
        // console.log("this.matricula:", this.matricula)
        // console.log("planoPagamento:", planoPagamento)
        if ( planoPagamento ) {
          matriculaService.savePlanosPagamento(idMatricula, planoPagamento)
          .then( response => {
            console.log('savePlanosPagamento', response.data)
            this.trackEtapaSalva(currentStep, params)
            this.goTo(params)
          })
          .catch( error => {
            console.error("Error savePlanosPagamento", error)
            this.trackEtapaErro(error)
          })
          .finally(() => {
            window.spinner.emit("close")
          })
        } else {
          this.goTo(params)
        }
        
      }

      if ( this.active.slug == 'contrato' ) {

        const idMatricula = this.idMatricula
        const planoPagamento = this.matricula.planoPagamento.codigo

        const data = {
          idMatricula: idMatricula,
          portal: "portalGestao"
        }
        
        console.log("idMatricula:", idMatricula)
        console.log("planoPagamento:", planoPagamento)

        const options = {
          title: 'Gravando Matrícula',
          titleAlign: "center",
          // message: "Se quiser uma mensagem...", //não obrigatório
          size: "small", //small, mid, large, full
          backdrop: true,
          backdropColor: "transparent",  //se o backdrop for false, não precisa
          backdropClose: false, //se o backdrop for false, não precisa
          fullHeight: false
        }
        
        this.$refs.modal.open(options)

        this.trackMatricula('contrato_geracao_iniciada', 'em_andamento', {
          step: currentStep,
          idMatricula: idMatricula
        })

        matriculaService.saveContrato(data)
        .then( responseContrato => {
          this.trackMatricula('contrato_enviado_docusign', 'aguardando_assinatura', {
            step: currentStep,
            idMatricula: idMatricula,
            envelopeId: responseContrato?.data?.envelopeId || null,
            metadata: {
              contratoStatus: responseContrato?.data?.contratoStatus || null
            }
          })

          this.$store.dispatch('matricula/save', this.steps).then(response => {
            const matriculaFinalizada = this.cloneData(response?.matricula || response || this.matricula)

            this.trackMatricula('matricula_finalizada_front', 'aguardando_assinatura', {
              step: currentStep,
              idMatricula: idMatricula
            })

            const confirmMessage = this.auto ? "Quero ir para o Shop Decisão" : "Ir para a central do aluno"
            const denyMessage = this.auto ? "Voltar para o App de Rematrículas" : "Não. Iniciar novo processo"
            
            console.log("confirmMessage:", confirmMessage)
            console.log("denyMessage:", denyMessage)

            this.$refs.confirm.run({
              message: "Matrícula concluída com sucesso.",
              obs: "<b class='color-primary'>Atenção!</b> Seu boleto estará disponível em até 48h.",
              confirmButton: confirmMessage,
              denyButton: denyMessage,
              size: 'mid',
              callback: this.endSession,
              data: matriculaFinalizada
            })
          })
        })
        .catch( error => {
          // console.error("Error savePlanosPagamento", error)
          this.trackMatricula('contrato_geracao_erro', 'erro', {
            step: currentStep,
            idMatricula: idMatricula,
            erro: this.mensagemErroTracking(error)
          })

          const data = error?.response?.data || {}
          var msg = data.error

          if ( !msg ) {
            msg = Object.values(data).join(", ")
          }
          msg = msg || error?.message || 'Erro desconhecido'

          this.$refs.modal.close()

          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Não conseguimos salvar os dados enviados: <b>" + msg + "</b>", floater: true})
        })
        .finally(() => {
          window.spinner.emit("close")
          this.$refs.modal.close()
        })
      }
    },
    endSession ( state, matricula ) {
      const matriculaFinalizada = this.cloneData(matricula?.matricula || matricula || this.matricula)

      this.$store.dispatch('matricula/clear', this.steps).then(() => {
        
        console.log("endSession.. state:", state)
        console.log("endSession.. matricula:", matriculaFinalizada)

        if ( state ) {
          if ( this.auto ) {
            window.location.href = "https://lojadecisao.com.br/loja/?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjY4ODAsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6ODAwMC9hcGkvYXV0aC9sb2dpbiIsImlhdCI6MTU2MzQ3NzY4NywiZXhwIjoxNTYzNDgxMjg3LCJuYmYiOjE1NjM0Nzc2ODcsImp0aSI6ImRtRjZsYUMwWUswVTdzSVIifQ.ynkU2CQ2Kr3yt-cxA3o21y2wkg2HRj-zckdBYDy2MNE&email=" + this.currentUser.email
          } else {
            const idPessoa = matriculaFinalizada?.aluno?.Basicos?.idPessoa
            const idAluno = matriculaFinalizada?.matricula?.idAluno

            if ( idPessoa && idAluno ) {
              this.$router.push({ name: 'Central do Aluno', params: { idAluno: idAluno, idPessoa: idPessoa } })
            } else {
              this.$router.push({ name: 'Matriculas', params: { action: 'nova' } })
            }
          }
          
        } else {
          if ( this.auto ) {
            this.$router.push({ name: 'App Rematrícula'})
          } else {
            this.$router.push({ name: 'Matriculas', params: { action: 'nova' } })
          }
          
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .mainSection {
    position: relative;
  }
  form {
    padding: 0 $hmg_mid $mg_large;
  }
</style>
